/**
 * Service for role assigned employees list operations
 */

import { apiClient } from '@/api/core/apiClient';
import { API_CONFIG } from '@/api/core/apiConfig';
import { buildQueryString } from '@/api/shared/queryBuilder';
import type { ApiResponse } from '@/api/shared/types';
import { mapRoleAssignedEmployeesListResultToModel } from './roleAssignedEmployees.mapper';
import {
  ROLE_ASSIGNED_EMPLOYEES_STATUS_FILTER,
  type LC_RoleAssignedEmployeesListOut,
  type RoleAssignedEmployeesExportFilters,
  type RoleAssignedEmployeesListFilters,
  type RoleAssignedEmployeesListResult,
} from './roleAssignedEmployees.types';


export class RoleAssignedEmployeesService {
  async list(
    filters?: RoleAssignedEmployeesListFilters,
    signal?: AbortSignal,
  ): Promise<ApiResponse<RoleAssignedEmployeesListResult>> {
    const params: Record<string, string | number | undefined | null> = { ...filters };
    if (params['status'] === ROLE_ASSIGNED_EMPLOYEES_STATUS_FILTER.ALL) {
      delete params['status'];
    }
    if (!params['orderBy']) {
      delete params['orderBy'];
      delete params['orderDirection'];
    }

    const queryString = buildQueryString(params);
    const endpoint = `${API_CONFIG.ENDPOINTS.AUTHORIZATION.ASSIGNED_EMPLOYEES}${queryString}`;

    const response = await apiClient.get<LC_RoleAssignedEmployeesListOut>(endpoint, { signal });

    if (response.success && response.data) {
      return {
        ...response,
        data: mapRoleAssignedEmployeesListResultToModel(response.data),
      };
    }

    return { ...response, data: null };
  }

  async export(
    filters?: RoleAssignedEmployeesExportFilters,
  ): Promise<ApiResponse<{ blob: Blob; filename: string }>> {
    const params: Record<string, string | undefined> = { ...filters };
    if (params['status'] === ROLE_ASSIGNED_EMPLOYEES_STATUS_FILTER.ALL) {
      delete params['status'];
    }

    const queryString = buildQueryString(params);
    const endpoint = `${API_CONFIG.ENDPOINTS.AUTHORIZATION.ASSIGNED_EMPLOYEES_FILE}${queryString}`;

    return apiClient.downloadBlobWithFilename(endpoint, { method: 'GET' });
  }
}

export const roleAssignedEmployeesService = new RoleAssignedEmployeesService();
